import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TalentJobOpportunitiesComponent } from "./talent-job-opportunities.component";
import { TranslateModule } from "@ngx-translate/core";
import { NzPageHeaderModule } from "ng-zorro-antd/page-header";
import { NzCardModule } from "ng-zorro-antd/card";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzEmptyModule } from "ng-zorro-antd/empty";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzPaginationModule } from "ng-zorro-antd/pagination";
import { ReactiveFormsModule } from "@angular/forms";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzModalModule } from "ng-zorro-antd/modal";
import { TagsOutputModule } from "../../../../../../../common-ui/src/lib/tags-output/tags-output.module";
import { LocationLabelModule } from "../../../../../../../common-ui/src/lib/location-label/location-label.module";
import { ViewJobOfferLocationModule } from "../../../../../../../common-ui/src/lib/view-job-offer-location/view-job-offer-location.module";
import { CreateConversationDialogModule } from "../../../../common-componnets/create-conversation-dialog/create-conversation-dialog.module";

@NgModule({
  declarations: [TalentJobOpportunitiesComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NzPageHeaderModule,
    NzCardModule,
    NzFormModule,
    NzSelectModule,
    NzButtonModule,
    NzEmptyModule,
    NzSpinModule,
    NzGridModule,
    NzPaginationModule,
    NzToolTipModule,
    NzIconModule,
    NzInputModule,
    NzModalModule,
    ReactiveFormsModule,
    TagsOutputModule,
    LocationLabelModule,
    ViewJobOfferLocationModule,
    CreateConversationDialogModule,
  ],
  exports: [TalentJobOpportunitiesComponent],
})
export class TalentJobOpportunitiesModule {}
